module.exports = __webpack_public_path__ + "assets/b117.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b117.png
// module id = 589
// module chunks = 0